export class Channel {

  constructor(name) {
    this.name = name
  }

}